<template>
  <div :class="rootClass" :style="rootStyle" :id="rendering?.dataSource">
    <ContentGrid :desktop-default-grid="[2, 20]" :mobile-default-grid="[1, 14]">
      <div class="health-card-list">
        <div class="health-card-list-item" v-for="item in fields?.list" :key="item.id">
          <div class="health-card-list-item-inner">
            <div
              class="health-card-list-item-front"
              :style="{ backgroundColor: item?.fields?.backgroundColor?.value }"
            >
              <div class="health-card-list-item-content">
                <div class="health-card-list-item-container">
                  <JssRichText class="health-card-list-item-title" :field="item?.fields?.title" />
                  <Icon :svg="fields?.icon?.value?.svgCode" class="health-card-list-item-icon" />
                </div>
                <JssRichText class="health-card-list-item-desc" :field="item?.fields?.desc" />
              </div>
              <AdaptiveImage
                class="health-card-list-item-image"
                :field="item?.fields?.image"
                :isBackground="false"
                :lazy-load="false"
                :enableScrollDetection="false"
                :show="true"
              />
            </div>
            <div class="health-card-list-item-back">
              <AdaptiveImage
                class="health-card-list-item-back-bg"
                :field="item?.fields?.hoverBg"
                :isBackground="true"
                :lazy-load="false"
                :enableScrollDetection="false"
                :show="true"
                :showImageRedius="false"
              >
                <JssRichText
                  class="health-card-list-item-back-title"
                  :field="item?.fields?.title"
                />
              </AdaptiveImage>
            </div>
          </div>
        </div>
      </div>
    </ContentGrid>
  </div>
</template>

<script>
import { computed } from 'vue';
import utils from '@/utils';

export default {
  name: 'HealthCard',
  props: {
    fields: {
      type: Object,
      default: () => ({}),
    },
    rendering: {
      type: Object,
    },
  },
  setup(props) {
    const rootClass = computed(() => utils.overall.baseComClass(props.fields, 'health-card'));

    const rootStyle = computed(() => {
      const result = utils.overall.baseComStyle(props.fields);
      return result;
    });

    return {
      rootClass,
      rootStyle,
    };
  },
};
</script>

<style lang="scss">
@import '../../styles/variables';
@import '../../styles/functions';
@import '../../styles/mixins';

.health-card {
  position: relative;
  width: 100%;
  padding: 40px 0;

  &-list {
    display: flex;
    flex-direction: column;
    gap: 20px;

    &-item {
      &-inner {
        position: relative;
        height: 100%;
      }

      &:nth-child(2) &-front {
        opacity: 0;
      }

      &:nth-child(2) &-back {
        opacity: 1;
      }

      &-front {
        height: 100%;
        display: flex;
        flex-direction: column;
        padding: 44px 20px;
        border-radius: 16px;
        justify-content: space-between;
        opacity: 1;
      }

      &-back {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        border-radius: 16px;
        overflow: hidden;
        opacity: 0;
        pointer-events: none;

        > div,
        .e-background-image {
          width: 100%;
          height: 100%;
        }

        .e-background-image__content {
          padding: 50px 30px;
        }

        &-title {
          font-size: 44px;
          font-weight: 600;
          color: $white;
        }
      }

      &-content {
        position: relative;
      }

      &-icon {
        width: 40px;
        height: 40px;

        svg {
          width: 40px;
          height: 40px;
        }
      }

      &-container {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 16px;
      }

      &-title {
        font-size: 24px;
        font-weight: 600;
        color: $black;
      }

      &-desc {
        font-size: 16px;
        font-weight: 400;
        color: $black;
        margin-top: 16px;
      }

      &-image {
        aspect-ratio: 348 / 185;
        margin-top: 30px;
      }
    }
  }

  @include tablet-landscape {
    padding: 60px 0;

    &-list {
      flex-direction: row;

      &-item {
        flex: 1;
      }
    }
  }
}
</style>
